// Conteúdo extraído fielmente do PDF "Corpo Conectado — Guia Visual Completo".
// sourcePages referem-se às páginas do PDF de origem. Nenhuma informação foi adicionada.

export const ORGANS = [
  {
    id: "pulmao",
    number: 1,
    name: "Pulmão",
    resumoMapa: "Responsável pela respiração e pela energia defensiva. Relaciona-se à tristeza e à pele.",
    subtitle: "O mestre da respiração e da energia.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Pulmão é responsável pela respiração, pela energia defensiva e pela relação com a tristeza e a pele. Quando o Pulmão está em equilíbrio, a vida flui com leveza.",
    funcao:
      "Responsável pela respiração, pela energia defensiva, relaciona-se à tristeza e à pele.",
    elemento: "metal",
    elementoLabel: "Metal",
    sabor: "Picante",
    emocao: "Tristeza",
    funcoesPrincipais: [
      "Protege o corpo contra agentes externos e fortalece a imunidade.",
      "Controla a respiração e a distribuição do Qi no corpo.",
      "Regula a água e os líquidos.",
      "Manifesta-se na pele e nos pelos corporais.",
      "Realiza a descida do Qi e ajuda na eliminação.",
    ],
    habitos: [
      "Respirar profundamente todos os dias.",
      "Manter o ambiente ventilado.",
      "Praticar caminhadas leves.",
      "Evitar excesso de tristeza acumulada.",
      "Cuidar da pele e da hidratação.",
      "Reservar momentos de silêncio e pausa.",
    ],
    chas: [
      { nome: "Chá de hortelã", beneficio: "refresca e ajuda a aliviar a sensação de vias respiratórias pesadas." },
      { nome: "Chá de gengibre", beneficio: "aquece e apoia a circulação de energia." },
      { nome: "Chá de tomilho", beneficio: "tradicionalmente associado ao cuidado respiratório." },
    ],
    alimentos: ["Pera cozida", "Arroz integral", "Nabo", "Cebola", "Gengibre", "Mel"],
    alimentosNota: "Alimentos mornos e simples costumam ser melhor recebidos pelo corpo.",
    evitar: [
      "Alimentos gelados",
      "Refrigerantes e bebidas muito frias",
      "Excesso de frituras",
      "Açúcar em excesso",
      "Ambientes muito secos",
      "Fumo e poluição",
    ],
    reflexao:
      "Pulmão em harmonia, respiração leve. Quando você se permite soltar, o corpo encontra espaço.",
    melhorHorario: "manhã ou fim da tarde. Beba chás mornos, sem excesso de açúcar.",
    relacoes: { parceiro: "intestino-grosso", parceiroLabel: "Intestino Grosso", podeAfetar: "pele, respiração e eliminação." },
    relogio: { periodo: "03h às 05h", descricao: "Período de maior atividade do Pulmão. Horário associado à respiração, descanso e renovação do Qi." },
    curiosidades: [
      "O Pulmão é chamado de “governador do Qi”. Ele inicia o ciclo da energia e influencia todo o corpo, como um ministro que organiza e protege o reino.",
      "Na MTC, o Pulmão é associado à capacidade de inspirar o novo e soltar o que já não precisa permanecer.",
    ],
    quandoProcurar: ["Falta de ar", "Dor forte no peito", "Tosse persistente", "Febre ou piora rápida", "Sintomas intensos ou preocupantes"],
    sourcePages: [12, 13],
  },
  {
    id: "intestino-grosso",
    number: 2,
    name: "Intestino Grosso",
    resumoMapa: "Elimina resíduos e absorve água. Relaciona-se à liberação e ao desapego.",
    subtitle: "O mestre da liberação e do desapego.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Intestino Grosso é associado à eliminação, à liberação do que não serve mais e à relação com o Pulmão, a pele e o desapego. Quando o Intestino Grosso está em equilíbrio, o corpo elimina com fluidez e a mente solta com leveza.",
    funcao:
      "Elimina resíduos, absorve água e auxilia o corpo a liberar excessos físicos e emocionais.",
    elemento: "metal",
    elementoLabel: "Metal",
    sabor: "Picante",
    emocao: "Desapego",
    funcoesPrincipais: [
      "Auxilia a eliminação.",
      "Absorve água.",
      "Trabalha em parceria com o Pulmão.",
      "Relaciona-se à pele.",
      "Ajuda a soltar excessos.",
    ],
    habitos: [
      "Beber água ao longo do dia.",
      "Manter horários regulares.",
      "Consumir fibras de forma equilibrada.",
      "Movimentar o corpo.",
      "Evitar reter vontades e emoções.",
      "Criar rituais de liberação.",
    ],
    chas: [
      { nome: "Chá de hortelã", beneficio: "refresca e apoia o conforto digestivo." },
      { nome: "Chá de funcho", beneficio: "tradicionalmente usado após as refeições." },
      { nome: "Chá de gengibre", beneficio: "aquece e apoia a circulação de energia." },
    ],
    alimentos: ["Aveia", "Mamão", "Linhaça", "Arroz integral", "Legumes cozidos", "Água morna"],
    alimentosNota: "Alimentos simples, naturais e fibras equilibram e nutrem o intestino.",
    evitar: [
      "Excesso de ultraprocessados",
      "Pouca água",
      "Alimentos muito secos",
      "Sedentarismo",
      "Açúcar em excesso",
      "Refeições apressadas",
    ],
    evitarAtencao: "Evitar hábitos que sobrecarregam o intestino ajuda a manter o fluxo natural e o conforto diário.",
    reflexao: "Soltar também é cuidar. Quando você libera excessos, abre espaço para o novo.",
    melhorHorario: "após as refeições. Prefira chás mornos e simples.",
    relacoes: { parceiro: "pulmao", parceiroLabel: "Pulmão", podeAfetar: "pele, respiração e eliminação." },
    relogio: { periodo: "05h às 07h", descricao: "Período de maior atividade do Intestino Grosso. Horário associado à eliminação e ao início do dia." },
    curiosidades: [
      "Na MTC, liberar faz parte do equilíbrio. O Intestino Grosso lembra que nem tudo precisa ser retido pelo corpo ou pela mente.",
      "Na MTC, o Intestino Grosso representa a arte de liberar o que já cumpriu seu papel.",
    ],
    quandoProcurar: ["Dor abdominal forte", "Sangue nas fezes", "Constipação persistente", "Diarreia frequente", "Mudança súbita do hábito intestinal"],
    sourcePages: [14, 15],
  },
  {
    id: "estomago",
    number: 3,
    name: "Estômago",
    resumoMapa: "Recebe e transforma os alimentos. Relaciona-se à preocupação.",
    subtitle: "O mestre da transformação dos alimentos.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Estômago recebe os alimentos e inicia sua transformação em energia. Relaciona-se à nutrição, à digestão e à preocupação. Quando o Estômago está em equilíbrio, o corpo recebe, transforma e se nutre com tranquilidade.",
    funcao: "Recebe e transforma os alimentos, apoiando a formação de energia e sangue.",
    elemento: "terra",
    elementoLabel: "Terra",
    sabor: "Doce Natural",
    emocao: "Preocupação",
    funcoesPrincipais: [
      "Recebe os alimentos.",
      "Inicia a digestão.",
      "Apoia a formação de energia.",
      "Relaciona-se à boca e ao apetite.",
      "Trabalha com o Baço-Pâncreas.",
    ],
    habitos: [
      "Comer em horários regulares.",
      "Preferir alimentos cozidos.",
      "Mastigar devagar.",
      "Evitar excessos.",
      "Reservar descanso após refeições.",
      "Cultivar pensamentos leves.",
    ],
    chas: [
      { nome: "Chá de gengibre", beneficio: "aquece e apoia a digestão." },
      { nome: "Chá de hortelã", beneficio: "tradicionalmente usado após refeições." },
      { nome: "Chá de camomila", beneficio: "acalma a rotina e suaviza tensões." },
    ],
    alimentos: ["Arroz integral", "Abóbora", "Batata-doce", "Gengibre", "Canela", "Maçã cozida"],
    alimentosNota: "Alimentos mornos e simples costumam ser melhor recebidos pelo Estômago.",
    evitar: [
      "Alimentos gelados",
      "Bebidas muito frias",
      "Frituras em excesso",
      "Doces em excesso",
      "Comer tarde da noite",
      "Excesso de cafeína",
    ],
    reflexao: "Estômago tranquilo, mente tranquila.",
    melhorHorario: "manhã e após refeições. Beba morno e sem excesso de açúcar.",
    relacoes: { parceiro: "baco-pancreas", parceiroLabel: "Baço-Pâncreas", podeAfetar: "digestão, energia e preocupação." },
    relogio: { periodo: "07h às 09h", descricao: "Período de maior atividade do Estômago. Horário ideal para uma refeição completa e nutritiva." },
    curiosidades: [
      "Na MTC, o Estômago é visto como uma fonte de nutrição. Ele ensina que receber bem também faz parte do equilíbrio.",
      "Na MTC, o Estômago recebe os alimentos e abre o caminho para transformar nutrição em energia.",
    ],
    quandoProcurar: ["Dor forte", "Vômitos frequentes", "Perda de peso inexplicada", "Sangue nas fezes ou vômitos", "Sintomas persistentes"],
    sourcePages: [16, 17],
  },
  {
    id: "baco-pancreas",
    number: 4,
    name: "Baço-Pâncreas",
    resumoMapa: "Transforma alimentos em energia e sangue. Relaciona-se à preocupação excessiva.",
    subtitle: "O mestre da nutrição e da transformação.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Baço-Pâncreas transforma alimentos em energia e sangue. Relaciona-se à nutrição, à estabilidade e à preocupação excessiva. Quando o Baço-Pâncreas está em equilíbrio, o corpo se sente nutrido, estável e com energia constante.",
    funcao: "Transforma alimentos em Qi e sangue, sustentando energia, foco e vitalidade.",
    elemento: "terra",
    elementoLabel: "Terra",
    sabor: "Doce Natural",
    emocao: "Preocupação",
    funcoesPrincipais: [
      "Transforma alimentos.",
      "Apoia energia e sangue.",
      "Sustenta músculos.",
      "Ajuda na concentração.",
      "Trabalha com o Estômago.",
    ],
    habitos: [
      "Comer em horários regulares.",
      "Preferir alimentos cozidos e mornos.",
      "Evitar excesso de açúcar.",
      "Mastigar com calma.",
      "Pausar entre tarefas.",
      "Organizar pensamentos.",
    ],
    chas: [
      { nome: "Chá de gengibre", beneficio: "aquece e apoia a transformação dos alimentos." },
      { nome: "Chá de erva-doce", beneficio: "tradicionalmente usado para conforto digestivo." },
      { nome: "Chá de camomila", beneficio: "suaviza tensões e apoia a rotina." },
    ],
    alimentos: ["Abóbora", "Arroz integral", "Batata-doce", "Cenoura cozida", "Aveia", "Canela"],
    alimentosNota: "Alimentos simples e mornos nutrem, aquecem e transformam melhor.",
    evitar: [
      "Açúcar em excesso",
      "Alimentos gelados",
      "Refeições muito pesadas",
      "Comer com pressa",
      "Excesso de preocupação",
      "Longos períodos sem comer",
    ],
    reflexao: "Nutrir-se bem também é acalmar a mente.",
    melhorHorario: "manhã e fim da tarde. Prefira bebidas mornas.",
    relacoes: { parceiro: "estomago", parceiroLabel: "Estômago", podeAfetar: "energia, músculos e digestão." },
    relogio: { periodo: "09h às 11h", descricao: "Período de maior atividade do Baço-Pâncreas. Horário associado ao foco e à transformação da energia." },
    curiosidades: [
      "Na MTC, o Baço-Pâncreas é visto como o centro que transforma nutrição em força para o corpo e clareza para a mente.",
      "Na MTC, o Baço-Pâncreas ajuda a transformar alimento em vitalidade e pensamento em clareza.",
    ],
    quandoProcurar: ["Cansaço intenso", "Inchaço persistente", "Perda de apetite", "Dor abdominal forte", "Sintomas prolongados"],
    sourcePages: [18, 19],
  },
  {
    id: "coracao",
    number: 5,
    name: "Coração",
    resumoMapa: "Governa o sangue e a mente. Relaciona-se à alegria equilibrada.",
    subtitle: "O mestre do sangue e da mente.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Coração governa o sangue e abriga a mente (Shen). Relaciona-se à alegria, à consciência e à tranquilidade interior. Quando o Coração está em equilíbrio, a alegria se expressa com calma, presença e clareza.",
    funcao: "Governa o sangue, acolhe o Shen e apoia a clareza mental e emocional.",
    elemento: "fogo",
    elementoLabel: "Fogo",
    sabor: "Amargo",
    emocao: "Alegria",
    funcoesPrincipais: [
      "Governa o sangue.",
      "Acolhe a mente.",
      "Relaciona-se ao sono.",
      "Expressa-se no brilho dos olhos.",
      "Apoia a comunicação.",
    ],
    habitos: [
      "Dormir em horários regulares.",
      "Cultivar alegria tranquila.",
      "Reduzir estímulos à noite.",
      "Praticar respiração calma.",
      "Conversar com quem ama.",
      "Reservar momentos de silêncio.",
    ],
    chas: [
      { nome: "Chá de camomila", beneficio: "acalma a rotina." },
      { nome: "Chá de melissa", beneficio: "tradicionalmente usado para relaxamento." },
      { nome: "Chá de lavanda", beneficio: "apoia uma pausa tranquila." },
    ],
    alimentos: ["Frutas vermelhas", "Maçã", "Aveia", "Sementes", "Folhas verdes", "Cacau amargo"],
    alimentosNota: "Alimentos naturais e simples nutrem o Coração e a alegria.",
    evitar: [
      "Excesso de estimulantes",
      "Noites mal dormidas",
      "Agitação constante",
      "Álcool em excesso",
      "Excesso de telas à noite",
      "Emoções intensas prolongadas",
    ],
    reflexao: "Coração sereno, mente clara.",
    melhorHorario: "fim da tarde ou noite. Evite estimulantes antes de dormir.",
    relacoes: { parceiro: "intestino-delgado", parceiroLabel: "Intestino Delgado", podeAfetar: "sono, mente e circulação." },
    relogio: { periodo: "11h às 13h", descricao: "Período de maior atividade do Coração. Horário associado à alegria, presença e pausa consciente." },
    curiosidades: [
      "Na MTC, o Coração é considerado o imperador do corpo, pois coordena presença, consciência e vitalidade.",
      "Na MTC, o Coração abriga o Shen, associado à consciência e à presença.",
    ],
    quandoProcurar: ["Dor no peito", "Falta de ar", "Palpitações intensas", "Desmaio", "Sintomas súbitos ou fortes"],
    sourcePages: [20, 21],
  },
  {
    id: "intestino-delgado",
    number: 6,
    name: "Intestino Delgado",
    resumoMapa: "Separa o puro do impuro nos alimentos. Relaciona-se à clareza e discernimento.",
    subtitle: "O mestre da clareza e do discernimento.",
    intro:
      "Na MTC, o Intestino Delgado separa o puro do impuro nos alimentos e nas experiências. Relaciona-se à clareza, ao discernimento e à capacidade de escolher. Quando está em equilíbrio, ajuda o corpo e a mente a distinguir o que nutre do que pesa.",
    funcao: "Separa o puro do impuro e apoia decisões claras.",
    elemento: "fogo",
    elementoLabel: "Fogo",
    sabor: "Amargo",
    emocao: "Clareza",
    funcoesPrincipais: [
      "Separa nutrientes.",
      "Apoia digestão.",
      "Auxilia decisões.",
      "Relaciona-se ao Coração.",
      "Organiza o que deve seguir.",
    ],
    habitos: [
      "Comer com calma.",
      "Evitar excesso de informações durante refeições.",
      "Organizar decisões.",
      "Praticar pausas mentais.",
      "Perceber o que nutre e o que pesa.",
      "Separar prioridades.",
    ],
    chas: [
      { nome: "Chá de camomila", beneficio: "suaviza tensões." },
      { nome: "Chá de hortelã", beneficio: "apoia conforto digestivo." },
      { nome: "Chá de erva-doce", beneficio: "tradicionalmente usado após refeições." },
    ],
    alimentos: ["Sopas leves", "Arroz integral", "Cenoura", "Abobrinha", "Maçã cozida", "Folhas verdes"],
    alimentosNota: "Alimentos leves e bem cozidos favorecem a absorção e o conforto digestivo.",
    evitar: [
      "Refeições apressadas",
      "Excesso de frituras",
      "Sobrecarga mental",
      "Comer distraído",
      "Bebidas muito frias",
      "Excesso de açúcar",
    ],
    reflexao:
      "Escutar o corpo e a mente ajuda a digerir não só alimentos, mas também experiências e emoções.",
    dicaCha: "Beba chás mornos, sem excesso de açúcar.",
    relacoes: { parceiro: "coracao", parceiroLabel: "Coração", podeAfetar: "digestão, clareza e escolhas." },
    relogio: { periodo: "13h às 15h", descricao: "Período de maior atividade do Intestino Delgado. Horário associado à absorção, seleção e transformação do que é essencial." },
    curiosidades: [
      "Na MTC, discernir é uma forma de cuidado: escolher o que entra, o que fica e o que deve sair.",
      "Na MTC, o Intestino Delgado simboliza a capacidade de separar o essencial do excesso.",
    ],
    quandoProcurar: ["Dor abdominal forte", "Vômitos persistentes", "Diarreia intensa", "Sangue nas fezes", "Sintomas prolongados"],
    sourcePages: [22, 23],
  },
  {
    id: "bexiga",
    number: 7,
    name: "Bexiga",
    resumoMapa: "Armazena e elimina urina. Relaciona-se à coragem.",
    subtitle: "A guardiã da água e da liberação.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), a Bexiga armazena e elimina a urina. Relaciona-se aos Rins, à circulação dos líquidos e à coragem diante do movimento da vida. Quando a Bexiga está em equilíbrio, o corpo libera excessos e mantém o fluxo dos líquidos com harmonia.",
    funcao: "Armazena e elimina urina, auxiliando o equilíbrio dos líquidos e a relação com os Rins.",
    elemento: "agua",
    elementoLabel: "Água",
    sabor: "Salgado",
    emocao: "Coragem",
    funcoesPrincipais: [
      "Armazena urina.",
      "Elimina líquidos.",
      "Trabalha com os Rins.",
      "Apoia o fluxo de energia.",
      "Relaciona-se à coragem.",
    ],
    habitos: [
      "Beber água ao longo do dia.",
      "Evitar segurar a urina por muito tempo.",
      "Manter o corpo aquecido.",
      "Movimentar-se com suavidade.",
      "Dormir bem.",
      "Cultivar coragem para agir.",
    ],
    chas: [
      { nome: "Chá de cavalinha", beneficio: "tradicionalmente associado aos líquidos." },
      { nome: "Chá de hibisco", beneficio: "usado em rotinas de leveza." },
      { nome: "Chá de cabelo de milho", beneficio: "tradicionalmente usado para vias urinárias." },
    ],
    alimentosTitulo: "Alimentos que favorecem",
    alimentos: ["Melancia", "Pepino", "Abobrinha", "Água", "Sopas leves", "Feijão azuki"],
    alimentosNota: "Prefira alimentos frescos e naturais, preparações leves e pouco sal.",
    evitar: ["Pouca água", "Excesso de sal", "Bebidas alcoólicas", "Segurar urina", "Frio excessivo", "Automedicação"],
    reflexao: "Fluxo equilibrado, corpo mais leve.",
    melhorHorario: "manhã e tarde. Use chás com orientação quando houver dúvidas.",
    relacoes: { parceiro: "rins", parceiroLabel: "Rins", podeAfetar: "líquidos, lombar e energia." },
    relogio: { periodo: "15h às 17h", descricao: "Período de maior atividade da Bexiga. Horário associado ao armazenamento, transformação e liberação." },
    curiosidades: [
      "Na MTC, a Bexiga lembra que fluir também exige confiança: reter demais pode pesar, liberar no tempo certo traz leveza.",
      "Na MTC, a Bexiga participa do caminho da água e do movimento de liberar excessos.",
    ],
    quandoProcurar: ["Dor ao urinar", "Sangue na urina", "Febre", "Dor lombar forte", "Sintomas persistentes"],
    sourcePages: [24, 25],
  },
  {
    id: "rins",
    number: 8,
    name: "Rins",
    resumoMapa: "Armazenam a essência vital. Relacionam-se ao medo e à força de vontade.",
    subtitle: "Os mestres da essência e da força interior.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), os Rins armazenam a essência vital (Jing). Relacionam-se à força de vontade, ao medo, à energia profunda e aos ciclos da vida. Quando os Rins estão em equilíbrio, a energia se torna mais estável, profunda e perseverante.",
    funcao: "Armazenam a essência vital, sustentam a força interior e apoiam o equilíbrio da água.",
    elemento: "agua",
    elementoLabel: "Água",
    sabor: "Salgado",
    emocao: "Medo",
    funcoesPrincipais: [
      "Armazenam o Jing.",
      "Apoiam ossos e lombar.",
      "Regulam a água.",
      "Sustentam força de vontade.",
      "Relacionam-se aos ouvidos.",
    ],
    habitos: [
      "Dormir cedo sempre que possível.",
      "Evitar excesso de esforço.",
      "Manter lombar e pés aquecidos.",
      "Beber água com regularidade.",
      "Praticar pausas restauradoras.",
      "Cultivar confiança e constância.",
    ],
    chas: [
      { nome: "Chá de cavalinha", beneficio: "tradicionalmente associado aos líquidos." },
      { nome: "Chá de gengibre", beneficio: "aquece e apoia a circulação." },
      { nome: "Chá de canela", beneficio: "usado em rotinas de aquecimento." },
    ],
    alimentos: ["Feijão preto", "Gergelim preto", "Nozes", "Sopas mornas", "Algas", "Água"],
    alimentosNota: "Prefira alimentos mornos e cozidos, que nutrem e aquecem.",
    evitar: ["Excesso de sal", "Frio intenso", "Pouco descanso", "Excesso de medo", "Estimulantes à noite", "Automedicação"],
    reflexao: "Energia profunda se constrói com descanso.",
    melhorHorario: "final da tarde. Beba chás mornos, em momentos de pausa.",
    relacoes: { parceiro: "bexiga", parceiroLabel: "Bexiga", podeAfetar: "ossos, lombar, ouvidos e energia." },
    relogio: { periodo: "17h às 19h", descricao: "Período de maior atividade dos Rins. Horário associado à reserva de energia e à vitalidade." },
    curiosidades: [
      "Na MTC, os Rins são como uma reserva preciosa: cuidar deles é preservar energia para o longo prazo.",
      "Na MTC, os Rins guardam o Jing, uma reserva de energia ligada aos ciclos da vida.",
    ],
    quandoProcurar: ["Dor lombar forte", "Inchaço persistente", "Alteração urinária", "Cansaço extremo", "Sintomas intensos"],
    sourcePages: [26, 27],
  },
  {
    id: "pericardio",
    number: 9,
    name: "Pericárdio",
    resumoMapa: "Protege o coração e acalma a mente. Relaciona-se à tranquilidade.",
    subtitle: "O guardião do coração e da tranquilidade.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Pericárdio protege o Coração e ajuda a acalmar a mente. Relaciona-se à tranquilidade, à proteção emocional e aos vínculos afetivos. Quando o Pericárdio está em equilíbrio, o coração se sente protegido e a mente encontra serenidade.",
    funcao: "Protege o Coração, acalma o Shen e apoia equilíbrio emocional.",
    elemento: "fogo",
    elementoLabel: "Fogo",
    sabor: "Amargo",
    emocao: "Tranquilidade",
    funcoesPrincipais: [
      "Protege o Coração.",
      "Acalma a mente.",
      "Apoia relações afetivas.",
      "Suaviza tensões emocionais.",
      "Trabalha com o Triplo Aquecedor.",
    ],
    habitos: [
      "Criar momentos de calma.",
      "Reduzir excesso de estímulos.",
      "Cultivar vínculos seguros.",
      "Respirar antes de reagir.",
      "Praticar gratidão.",
      "Proteger seus limites emocionais.",
    ],
    chas: [
      { nome: "Chá de melissa", beneficio: "tradicionalmente usado para relaxar." },
      { nome: "Chá de camomila", beneficio: "suaviza tensões." },
      { nome: "Chá de lavanda", beneficio: "apoia momentos de pausa." },
    ],
    alimentos: ["Frutas vermelhas", "Aveia", "Folhas verdes", "Sementes", "Maçã", "Cacau amargo"],
    alimentosNota: "Prefira alimentos naturais e preparados com presença e intenção.",
    evitar: [
      "Excesso de estresse",
      "Noites agitadas",
      "Discussões constantes",
      "Estimulantes à noite",
      "Álcool em excesso",
      "Ignorar limites emocionais",
    ],
    evitarAtencao: "Atenção: hábitos que sobrecarregam o Pericárdio podem afetar o coração e as emoções.",
    reflexao: "Pericárdio em harmonia, coração protegido, emoções acolhidas e relações mais leves.",
    melhorHorario: "final da tarde ou início da noite. Crie um ritual de chá para sinalizar o tempo de desacelerar.",
    relacoes: { parceiro: "triplo-aquecedor", parceiroLabel: "Triplo Aquecedor", podeAfetar: "coração, mente e vínculos." },
    relogio: { periodo: "19h às 21h", descricao: "Período de maior atividade do Pericárdio. Horário associado à proteção do coração e à serenidade emocional." },
    curiosidades: [
      "Na MTC, o Pericárdio é como um escudo gentil: protege sem fechar o coração para a vida.",
      "Na MTC, o Pericárdio ajuda a proteger o coração sem impedir a troca afetiva.",
    ],
    quandoProcurar: ["Dor no peito", "Palpitações fortes", "Falta de ar", "Crise intensa de ansiedade", "Sintomas súbitos"],
    sourcePages: [28, 29],
  },
  {
    id: "triplo-aquecedor",
    number: 10,
    name: "Triplo Aquecedor",
    resumoMapa: "Regula o metabolismo e a distribuição de energia. Relaciona-se ao equilíbrio geral.",
    subtitle: "O mestre da circulação do Qi e dos líquidos.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Triplo Aquecedor regula a circulação do Qi, dos líquidos e do calor entre as regiões superior, média e inferior do corpo. Relaciona-se ao equilíbrio geral. Quando o Triplo Aquecedor está em equilíbrio, a energia circula melhor entre respiração, digestão e eliminação.",
    funcao: "Coordena a distribuição do Qi, dos líquidos e do calor nas três regiões do corpo.",
    elemento: "fogo",
    elementoLabel: "Fogo",
    sabor: "Amargo",
    emocao: "Equilíbrio",
    funcoesPrincipais: [
      "Distribui o Qi.",
      "Regula líquidos.",
      "Integra três regiões.",
      "Apoia metabolismo.",
      "Trabalha com o Pericárdio.",
    ],
    habitos: [
      "Manter rotina regular.",
      "Respirar profundamente.",
      "Evitar excesso de calor e estresse.",
      "Alternar atividade e descanso.",
      "Hidratar-se ao longo do dia.",
      "Organizar sono, alimentação e movimento.",
    ],
    chas: [
      { nome: "Chá de camomila", beneficio: "suaviza a rotina." },
      { nome: "Chá de hortelã", beneficio: "refresca e traz leveza." },
      { nome: "Chá de gengibre", beneficio: "aquece quando há frio interno." },
    ],
    alimentos: ["Sopas leves", "Água", "Legumes cozidos", "Arroz integral", "Folhas verdes", "Frutas frescas"],
    alimentosNota: "Prefira alimentos leves, frescos e bem preparados para manter a circulação de energia e líquidos.",
    evitar: ["Rotina caótica", "Excesso de estresse", "Pouco sono", "Extremos alimentares", "Sedentarismo", "Automedicação"],
    reflexao: "Quando sua rotina flui com leveza, o corpo mantém o equilíbrio entre calor, energia e líquidos.",
    melhorHorario: "final da tarde ou à noite. Beba chás mornos, sem excesso de açúcar.",
    relacoes: { parceiro: "pericardio", parceiroLabel: "Pericárdio", podeAfetar: "metabolismo, líquidos e equilíbrio geral." },
    relogio: { periodo: "21h às 23h", descricao: "Período de maior atividade do Triplo Aquecedor." },
    curiosidades: [
      "Na MTC, o Triplo Aquecedor não é um órgão anatômico isolado, mas uma função energética de integração do corpo.",
      "Na MTC, o Triplo Aquecedor integra as três regiões do corpo para que energia, calor e líquidos circulem melhor.",
    ],
    quandoProcurar: ["Febre persistente", "Inchaço intenso", "Falta de ar", "Mal-estar forte", "Sintomas súbitos"],
    sourcePages: [30, 31],
  },
  {
    id: "vesicula-biliar",
    number: 11,
    name: "Vesícula Biliar",
    resumoMapa: "Armazena e libera a bile. Relaciona-se à coragem e à tomada de decisões.",
    subtitle: "A mestre da coragem e das decisões.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), a Vesícula Biliar armazena e libera a bile. Relaciona-se à coragem, à iniciativa e à tomada de decisões. Quando a Vesícula Biliar está em equilíbrio, as escolhas se tornam mais firmes, claras e alinhadas.",
    funcao: "Armazena e libera a bile, apoiando decisões, coragem e movimento.",
    elemento: "madeira",
    elementoLabel: "Madeira",
    sabor: "Azedo",
    emocao: "Coragem",
    funcoesPrincipais: [
      "Libera a bile.",
      "Apoia decisões.",
      "Relaciona-se ao Fígado.",
      "Estimula iniciativa.",
      "Ajuda no movimento do Qi.",
    ],
    habitos: [
      "Tomar decisões pequenas com clareza.",
      "Movimentar o corpo.",
      "Alongar laterais do corpo.",
      "Evitar guardar irritação.",
      "Dormir antes de muito tarde.",
      "Planejar sem rigidez.",
    ],
    chas: [
      { nome: "Chá de boldo", beneficio: "tradicionalmente associado à bile." },
      { nome: "Chá de hortelã", beneficio: "refresca e apoia conforto digestivo." },
      { nome: "Chá de carqueja", beneficio: "tradicionalmente usado em rotinas digestivas." },
    ],
    alimentos: ["Limão", "Folhas verdes", "Alcachofra", "Rabanete", "Azeite", "Maçã"],
    alimentosNota: "Alimentos naturais e leves favorecem o fluxo da bile e a leveza do corpo.",
    evitar: ["Gorduras em excesso", "Álcool em excesso", "Refeições muito pesadas", "Raiva acumulada", "Noites muito tardias", "Automedicação"],
    reflexao: "Clareza nas pequenas escolhas alivia a mente e favorece o fluxo da bile e do Qi.",
    melhorHorario: "manhã ou após as refeições. Beba chás mornos, sem excesso de açúcar.",
    relacoes: { parceiro: "figado", parceiroLabel: "Fígado", podeAfetar: "decisões, bile e fluxo do Qi." },
    relogio: { periodo: "23h à 1h", descricao: "Período de maior atividade da Vesícula Biliar. Horário associado à decisão, coragem e ao fluxo da bile e do Qi." },
    curiosidades: [
      "Na MTC, decidir também é energia: a Vesícula Biliar ajuda a transformar intenção em ação.",
      "Na MTC, a Vesícula Biliar representa a coragem para decidir e seguir adiante.",
    ],
    quandoProcurar: ["Dor forte do lado direito", "Febre", "Vômitos persistentes", "Pele ou olhos amarelados", "Sintomas intensos"],
    sourcePages: [32, 33],
  },
  {
    id: "figado",
    number: 12,
    name: "Fígado",
    resumoMapa: "Garante o fluxo livre de energia. Relaciona-se à raiva e ao planejamento.",
    subtitle: "O mestre do fluxo livre de energia.",
    intro:
      "Na Medicina Tradicional Chinesa (MTC), o Fígado garante o fluxo livre do Qi. Relaciona-se à raiva, ao planejamento, à visão e à capacidade de seguir em frente. Quando o Fígado está em equilíbrio, a energia circula com suavidade e as decisões ganham direção.",
    funcao: "Mantém o fluxo livre do Qi, armazena sangue e apoia planejamento, movimento e visão.",
    elemento: "madeira",
    elementoLabel: "Madeira",
    sabor: "Azedo",
    emocao: "Raiva",
    funcoesPrincipais: [
      "Move o Qi.",
      "Armazena sangue.",
      "Apoia planejamento.",
      "Relaciona-se aos olhos.",
      "Trabalha com a Vesícula Biliar.",
    ],
    habitos: [
      "Movimentar o corpo diariamente.",
      "Alongar pescoço e laterais.",
      "Respirar ao sentir irritação.",
      "Planejar com flexibilidade.",
      "Dormir bem.",
      "Expressar emoções com respeito.",
    ],
    chas: [
      { nome: "Chá de boldo", beneficio: "tradicionalmente associado ao fígado e à bile." },
      { nome: "Chá de hortelã", beneficio: "refresca e traz leveza." },
      { nome: "Chá de dente-de-leão", beneficio: "tradicionalmente usado em rotinas de cuidado hepático." },
    ],
    alimentos: ["Folhas verdes", "Limão", "Alcachofra", "Beterraba", "Maçã", "Gengibre"],
    alimentosNota: "Escolhas naturais apoiam o fígado e favorecem o fluxo do Qi.",
    evitar: ["Álcool em excesso", "Gorduras em excesso", "Raiva acumulada", "Noites mal dormidas", "Sedentarismo", "Automedicação"],
    reflexao: "Um Fígado equilibrado favorece o fluxo, a clareza de ideias e emoções mais leves. Permita-se fluir.",
    melhorHorario: "manhã ou início da tarde. Prefira chás naturais e mantenha bons intervalos de hidratação.",
    relacoes: { parceiro: "vesicula-biliar", parceiroLabel: "Vesícula Biliar", podeAfetar: "olhos, tendões, planejamento e fluxo do Qi." },
    relogio: { periodo: "1h às 3h", descricao: "Período de maior atividade do Fígado. Horário associado ao planejamento, desintoxicação e ao livre fluxo do Qi." },
    curiosidades: [
      "Na MTC, o Fígado é como uma árvore: precisa de espaço para crescer, flexibilidade para se adaptar e direção para florescer.",
      "Na MTC, o Fígado gosta de movimento suave e liberdade. Quando há rigidez, o fluxo do Qi pode ficar bloqueado.",
    ],
    quandoProcurar: ["Dor forte do lado direito", "Pele ou olhos amarelados", "Vômitos persistentes", "Urina muito escura", "Sintomas intensos"],
    sourcePages: [34, 35],
  },
];

export const getOrgan = (id) => ORGANS.find((o) => o.id === id);

// Página física 5 / impressa 3: Conheça seu corpo
export const CONHECA_SEU_CORPO = {
  titulo: "Conheça seu corpo",
  subtitulo: "Tudo está conectado.",
  texto1:
    "Na visão da Medicina Tradicional Chinesa (MTC), cada órgão tem uma função específica, mas nenhum trabalha sozinho. Eles se comunicam constantemente por meio de canais de energia, emoções, alimentação, ambiente e hábitos diários.",
  texto2:
    "Entender essas conexões é o primeiro passo para cuidar de você de forma íntegra, consciente e preventiva.",
  comoLerMapa: {
    titulo: "Como ler este mapa",
    pontos: [
      "Cada número representa um dos 12 órgãos e vísceras principais da MTC.",
      "As linhas ilustram os meridianos que conectam os órgãos a todo o corpo.",
      "Esse sistema forma uma rede inteligente que mantém o equilíbrio do corpo e da mente.",
      "Quando um órgão entra em desequilíbrio, o corpo envia sinais. Aprender a interpretá-los é fundamental.",
    ],
  },
  lembrete:
    "Este guia apresenta a visão da Medicina Tradicional Chinesa. O objetivo é educar e inspirar escolhas conscientes para o seu bem-estar.",
  source: { pdfPage: 5, printedPage: "3" },
};

// Página física 6 / impressa 4: A visão integrativa
export const VISAO_INTEGRATIVA = {
  titulo: "A visão integrativa",
  subtitulo:
    "Cada órgão possui um papel essencial no equilíbrio do corpo e se relaciona com emoções, horários, elementos e sabores específicos.",
  descricao:
    "Corpo, mente, emoções, ambiente e espírito são vistos como uma unidade. Quando um deles está em desequilíbrio, os outros também sofrem impacto.",
  etapas: [
    "Órgãos em equilíbrio",
    "Emoções em harmonia",
    "Escolhas conscientes",
    "Energia fluindo",
  ],
  source: { pdfPage: 6, printedPage: "4" },
};
